import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import {routes} from './routers'
import store from './Store/Store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios';
import VueAxios from 'vue-axios'
import VueSimpleAlert from "vue-simple-alert";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {  fas   } from '@fortawesome/free-solid-svg-icons'
import { faArrowAltCircleUp,faLongArrowAltLeft,faAngleDown,faAngleRight,faRetweet,faSortDown,faUndo,faPlus,faStar,faRulerCombined,faEuroSign,faMapMarkedAlt,faLongArrowAltRight,faBell,faFolderOpen,faTachometerAlt,faBuilding,faSignOutAlt,faUserFriends,faUserAlt,faFile,faSuitcase,faWrench,faBook,faSearch,faTrash,faEdit,faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import Multiselect from 'vue-multiselect';
import VueLoading from 'vuejs-loading-plugin'
import VueSweetalert2 from 'vue-sweetalert2';

import { isLoggedIn,loginUser } from './utils/auth'
import Store from './Store/Store'
 
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
library.add(fas)
library.add(faArrowAltCircleUp,faLongArrowAltLeft,faAngleDown,faAngleRight,faRetweet,faSortDown,faUndo,faPlus,faStar,faRulerCombined,faEuroSign,faMapMarkedAlt,faLongArrowAltRight,faFolderOpen,faTachometerAlt,faBuilding,faSignOutAlt,faUserFriends,faUserAlt,faFile,faSuitcase,faWrench,faBook,faSearch,faTrash,faEdit,faExternalLinkAlt, faBell)
Vue.component('fa-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(VueSimpleAlert);
Vue.use(VueRouter)
Vue.use(Multiselect);
Vue.use(VueLoading)
Vue.use(VueSweetalert2);

Vue.use(VueAxios,axios);


const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
  mode: 'history'
})

export function decryptPassword(param) {
  var res = param.split(",");
  var decrypt =""
  for(var i=0; i<res.length; i++) {
    decrypt += String.fromCharCode(1990 - parseInt(res[i]))
  }
  return decrypt
}

router.beforeEach((to, from, next) => {
  if (to.name == 'login' && isLoggedIn()) {
      if(to.query.pid && to.query.p) {
        var project_id = to.query.pid
        var dossier = to.query.d
  
        localStorage.setItem("project_id", project_id)
        localStorage.setItem("dossier", dossier)
        var login = to.query.l
        var encrypted = to.query.p
        var password = decryptPassword(encrypted)
        
        
  
        if(project_id != undefined && login != undefined && password != undefined) {
          window.history.pushState({}, document.title, window.location.pathname);

          try {
            loginUser(login, password)

            if(to.query.type!=undefined){
              
              next({ path: '/Comparateur-ancien' })
            }else{
              next({ path: '/Comparateur' })
            }
           // next({ path: '/Comparateur' })
          }catch (err) {
            alert(`Error: ${err}`)
          }

        } 
        else {
          localStorage.setItem("project_id", -1)
        }
      }
 
    else {
      next({ path: '/' })
    }
  }
  
  else if (!to.meta.allowAnonymous && !isLoggedIn()) {
    console.log('here')
    next({
      path: '/user/login',
      query: { redirect: to.fullPath }
    })
  }
  else {
    next()
  }  
})
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
})
